<template>
  <div :class="['aside',isCollapse ? 'collapse':'expand']">
    <div class="toggle" @click="handleToggle">
      <i :class="iconClass" class="toggle-icon" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false
    };
  },
  computed: {
    iconClass() {
      if (this.isCollapse) {
        return "el-icon-arrow-right";
      }
      return "el-icon-arrow-left";
    }
  },
  methods: {
    handleToggle() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>

<style scoped lang="scss">
.aside {
  height: 100%;
  transition: all 0.38s;
  background: #fff;
  position: relative;

  .toggle {
    position: absolute;
    z-index: 10;
    top: calc(50% - 20px);
    cursor: pointer;
    transition: left 0.38s;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    display: inline-block;

    .toggle-icon {
      position: absolute;
      top: -9px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.collapse {
  width: 0;

  .toggle {
    left: 0;
    border-left: 15px solid #f7f7f7;

    .toggle-icon {
      left: -20px;
    }
  }
}

.expand {
  width: 300px;
  margin-right: 15px;

  .toggle {
    left: 285px;
    border-right: 15px solid #f7f7f7;

    .toggle-icon {
      left: 2px;
    }
  }
}
</style>